(function () {
  'use strict';

  function normalizedText(node) {
    return (node.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function cleanDescriptionSizeLabels(scope) {
    var root = scope || document;
    var descriptions = [];
    if (root.matches && root.matches('.dv-product-accordion-item--description .rte')) descriptions.push(root);
    if (root.querySelectorAll) descriptions = descriptions.concat(Array.prototype.slice.call(root.querySelectorAll('.dv-product-accordion-item--description .rte')));
    descriptions.forEach(function (description) {
      Array.prototype.slice.call(description.querySelectorAll('p, div, span, strong, b')).forEach(function (node) {
        if (!node.isConnected || normalizedText(node) !== 'size:') return;
        var parent = node.parentElement;
        node.remove();
        if (parent && parent !== description && normalizedText(parent) === '') parent.remove();
      });
      Array.prototype.slice.call(description.childNodes).forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE && normalizedText(node) === 'size:') node.remove();
      });
    });
  }

  function init() {
    cleanDescriptionSizeLabels();
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) cleanDescriptionSizeLabels(node.closest('.dv-product-accordion-item--description .rte') || node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
